import { ITextValue } from '@/types/common';

import { AvailabilityStatusEnum, IAvailability } from '../types';

export * from './headers/availabilitiesHeadersData';
export * from './mapHelpers';
export * from './generateMapFeaturesFromAvailabilityList';
export * from './getDateAvailableLabel';
export * from './getAvailabilityTIAllowanceLabel';
export * from './getMonthsOnMarket';

export const getAvailabilityStatusLabel = (status: AvailabilityStatusEnum) => {
  switch (status) {
    case AvailabilityStatusEnum.Active: return AvailabilityStatusEnum.Active;
    case AvailabilityStatusEnum.Inactive: return AvailabilityStatusEnum.Inactive;
    case AvailabilityStatusEnum.Leased: return AvailabilityStatusEnum.Leased;
    case AvailabilityStatusEnum.Sold: return AvailabilityStatusEnum.Sold;
    case AvailabilityStatusEnum.Pending: return 'Listing Pending';
    case AvailabilityStatusEnum.Withdrawn: return AvailabilityStatusEnum.Withdrawn;
  }
}

export const getAvailabilityStatusItems = (): ITextValue<AvailabilityStatusEnum>[] => {
  return [
    { text: getAvailabilityStatusLabel(AvailabilityStatusEnum.Active), value: AvailabilityStatusEnum.Active },
    { text: getAvailabilityStatusLabel(AvailabilityStatusEnum.Inactive), value: AvailabilityStatusEnum.Inactive },
    { text: getAvailabilityStatusLabel(AvailabilityStatusEnum.Leased), value: AvailabilityStatusEnum.Leased },
    { text: getAvailabilityStatusLabel(AvailabilityStatusEnum.Sold), value: AvailabilityStatusEnum.Sold },
    { text: getAvailabilityStatusLabel(AvailabilityStatusEnum.Pending), value: AvailabilityStatusEnum.Pending },
    { text: getAvailabilityStatusLabel(AvailabilityStatusEnum.Withdrawn), value: AvailabilityStatusEnum.Withdrawn },
  ];
};

export const getPublishedToWebByAvailabilityData = (availability: IAvailability) => {
  const { published_to_web, status, in_house, agency_type } = availability;

  if (!!published_to_web?.updated?.name && published_to_web.updated.name !== 'System') {
    return published_to_web;
  }

  return {
    value: status === 'Active' && in_house && agency_type === 'Exclusive',
    updated: {
      date: Date.now(),
      name: 'System',
      id: 0
    }
  };
};
